/*
 * Copyright (c) 2023. Collabro Limited
 */
import React from "react";
import { styled } from "@mui/material";

const AnimatedLogo = () => {
  const AnimatedArrow = styled("path")({
    "@keyframes arrow1": {
      "0%": {
        transform: "translate(0px,0px)",
      },
      "50%": {
        transform: "translate(-300px,0px)",
      },
      "100%": {
        transform: "translate(0px,0px)",
      },
    },
    WebkitAnimationName: "arrow1",
    WebkitAnimationDuration: "3000ms",
    WebkitAnimationIterationCount: "infinite",
    WebkitAnimationTimingFunction: "linear",
    animationName: "arrow1",
    animationDuration: "3000ms",
    animationIterationCount: "infinite",
    animationTimingFunction: "linear",
  });

  const AnimatedLogo = styled("path")({
    "@keyframes arrow2": {
      "0%": {
        transform: "scale(1)",
      },
      "50%": {
        transform: "scale(1.04)",
      },
      "100%": {
        transform: "scale(1)",
      },
    },
    WebkitAnimationName: "arrow2",
    WebkitAnimationDuration: "3000ms",
    WebkitAnimationIterationCount: "infinite",
    WebkitAnimationTimingFunction: "linear",
    animationName: "arrow2",
    animationDuration: "3000ms",
    animationIterationCount: "infinite",
    animationTimingFunction: "linear",
  });

  return (
    <svg
      viewBox="0 60 466.5 432"
      xmlns="http://www.w3.org/2000/svg"
      height={100}
    >
      <g transform="matrix(.1 0 0 -.1 0 504)">
        <AnimatedLogo
          d="m1557 3814c-400-201-726-368-723-372 8-13 1445-727 1451-721 3 3 4 332 3 731l-3 726-728-364z"
          fill="#f58e20"
        />
        <AnimatedLogo
          d="m2480 3450c0-401 3-730 8-729 4 0 333 164 732 363l725 364-733 366-732 366v-730z"
          fill="#fab875"
        />
        <AnimatedArrow
          d="m830 3055v-195h-275-275l2-337 3-338 273-3 272-2v-195-195l732 366 733 366-725 364c-399 199-728 363-732 363-5 1-8-87-8-194z"
          fill="#7a6d6b"
        />
        <AnimatedLogo
          d="m3200 2886-725-363 723-362c397-198 726-361 732-361 7 0 10 247 10 725 0 399-3 725-7 724-5 0-334-164-733-363z"
          fill="#b3a8a5"
        />
        <AnimatedLogo
          d="m1553 1957c-398-199-723-364-723-367 0-5 1445-730 1455-730 3 0 5 329 5 730 0 402-3 730-7 729-5 0-333-163-730-362z"
          fill="#f58e20"
        />
        <AnimatedLogo
          d="m2480 1590c0-401 2-730 5-730 10 0 1455 725 1455 730s-1445 730-1455 730c-3 0-5-328-5-730z"
          fill="#fab875"
        />
      </g>
    </svg>
  );
};

export default AnimatedLogo;
